import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { OverlayContainer } from "@angular/cdk/overlay";
import { Directive, ElementRef, HostListener, Inject, Input, OnInit, Optional, Renderer2 } from "@angular/core";
import { MatLegacyMenuTrigger as MatMenuTrigger } from "@angular/material/legacy-menu";
import { MAT_GLOBAL_CONFIG, MatGlobalConfig } from "@obg/mat.ui.global";
import { coerceBoolean, DocumentRef } from "@obg/ngx.global.evo";

import { TOOLTIP_RIGHT_ALIGNED_CLASSNAME } from "./tooltip.const";

/**
 * TODO: #BXEL-180.
 * This whole directive needs to be absolutely refactored.
 * Code is deprecated.
 * Caution advised since a lot of features use this directive.
 */
@Directive({
	selector: "[obgMatTooltip]",
})
export class TooltipDirective implements OnInit {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input("obgMatTooltipDisabled") set setObgMatTooltipDisabled(value: boolean) {
		this.obgMatTooltipDisabled = this.globalTooltipDisabled || coerceBooleanProperty(value);
	}

	@coerceBoolean() @Input() obgMatTooltipRightAligned = false;

	obgMatTooltipDisabled: boolean;
	globalTooltipDisabled: boolean;

	constructor(
		@Optional() @Inject(MAT_GLOBAL_CONFIG) globalConfig: MatGlobalConfig | null,
		private renderer: Renderer2,
		private trigger: MatMenuTrigger,
		private overlayContainer: OverlayContainer,
		private elementRef: ElementRef,
		private documentRef: DocumentRef
	) {
		this.globalTooltipDisabled = globalConfig?.tooltip?.disabled || false;
		this.obgMatTooltipDisabled = this.globalTooltipDisabled;
		const saveOpenMenu = this.trigger.openMenu.bind(this.trigger);
		this.trigger.openMenu = () => !this.obgMatTooltipDisabled && saveOpenMenu();
		this.trigger.restoreFocus = false;

		const overlayContainerElement = this.overlayContainer.getContainerElement();
		this.renderer.setProperty(overlayContainerElement, "@.disabled", true);
	}

	@HostListener("focusout")
	@HostListener("blur")
	closeMenu() {
		this.trigger.closeMenu();
	}

	@HostListener("keyup.tab")
	openMenuWithTab() {
		this.trigger.openMenu();
	}

	@HostListener("menuOpened")
	rightAlignMenu() {
		if (!(this.obgMatTooltipRightAligned && this.trigger?.menu?.panelId)) {
			return;
		}

		const { offsetWidth } = this.elementRef.nativeElement;
		const element = this.documentRef.native.getElementById(this.trigger?.menu?.panelId);
		this.renderer.addClass(element, TOOLTIP_RIGHT_ALIGNED_CLASSNAME);
		this.renderer.setStyle(element, "left", `${offsetWidth}px`);
	}

	@HostListener("keydown", ["$event"])
	closeMenuWithTab(event: KeyboardEvent) {
		// if user types something or autofiller is used ("" case)
		if (event.key !== "Tab" && event.key !== "" && this.trigger.menuClosed) {
			this.openTriggerMenu();
			return;
		}
		this.trigger.closeMenu();
	}

	ngOnInit() {
		if (this.trigger.menu) {
			this.trigger.menu.hasBackdrop = false;
		}
	}

	private openTriggerMenu() {
		// by closing the current focus, it gives time to focus in next tooltip element
		// this will avoid having multiple tooltips opened at the same time
		this.trigger.closeMenu();
		this.trigger.openMenu();
	}
}
